export const HOST = (() => {
  if (process.env.NODE_ENV === 'development') {
    return `${location.protocol}//local.ycbaoxiao.com/`
  }
  if (location.host === 'bx.index.zerocs.cn/') {
    return `${location.protocol}//bx.zerocs.cn/`
  }
  return `${location.protocol}//bx.zerocs.cn/`
})()



// WEBPACK FOOTER //
// ./src/host.js